export const PLATFORM_TYPE = {
  /* eslint no-useless-computed-key: "off" */
  [1]: '阿里云平台'
}

/** 签名审核状态 */
export const SIGN_STATUS = {
  [0]: '审核中',
  [1]: '审核通过',
  [2]: '审核未通过'
}

/** 签名类型 */
export const SIGN_TYPE = {
  [0]: '验证码',
  [1]: '通用',
  [2]: '推广短信'
}

export const platformOptions = [
  {
    value: '',
    label: '全部平台'
  },
  {
    value: 1,
    label: '阿里云平台'
  }
]

/** 签名审核状态select */
export const signStatusOptions = [
  {
    value: 0,
    label: '审核中'
  },
  {
    value: 1,
    label: '审核通过'
  },
  {
    value: 2,
    label: '审核未通过'
  }
]

/** 签名类型select */
export const signTypeOptions = [
  {
    value: 0,
    label: '验证码'
  },
  {
    value: 1,
    label: '通用'
  }
]

export const tableDataSchemas = [
  {
    prop: 'appName',
    label: '短信接入方名称',
    minWidth: 120
  },
  {
    prop: 'platform',
    label: '平台',
    minWidth: 120
  },
  {
    prop: 'signName',
    label: '短信签名名称',
    minWidth: 120
  },
  {
    prop: 'reason',
    label: '签名审核备注',
    minWidth: 120
  },
  {
    prop: 'remark',
    label: '备注',
    minWidth: 120
  },
  {
    prop: 'signStatus',
    label: '签名审核状态',
    minWidth: 120
  },
  {
    prop: 'signType',
    label: '签名类型',
    minWidth: 120
  }
]

// 基础设置 form
export const formSchemas = [
  {
    field: 'appName',
    defaultValue: '',
    component: 'Input',
    label: '短信接入方名称',
    placeholder: '请输入短信接入方名称',
    rules: [
      {
        required: true,
        message: '短信接入方名称不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'appId',
    defaultValue: '',
    component: 'Input',
    label: '短信接入方唯一标识',
    placeholder: '请输入短信接入方唯一标识',
    rules: [
      {
        required: true,
        message: '短信接入方唯一标识不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'platform',
    defaultValue: '1',
    component: 'Radio',
    label: '短信平台',
    placeholder: '请输入短信平台',
    radioArr: [
      {
        label: '阿里云平台',
        value: '1'
      }
    ]
  },
  {
    field: 'signName',
    defaultValue: '',
    component: 'Input',
    label: '短信签名名称',
    placeholder: '请输入短信签名名称',
    rules: [
      {
        required: true,
        message: '短信签名名称不能为空'
      }
    ],
    trigger: ['blur']
  },
  {
    field: 'remark',
    defaultValue: '',
    component: 'InputTextArea',
    label: '备注',
    placeholder: '请输入备注',
    rules: [],
    trigger: ['blur']
  }
]
